import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const { t } = useTranslation();

  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.label,
      item: item.path ? `https://www.kuaimaovideo.com${item.path}` : undefined,
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
      <nav aria-label="面包屑导航" className="container-page py-3">
        <ol className="flex items-center flex-wrap text-sm text-foreground-500">
          <li className="flex items-center">
            <Link to="/" className="hover:text-primary-500 transition-colors whitespace-nowrap">
              <i className="ri-home-4-line mr-1"></i>
              {t("breadcrumb.home")}
            </Link>
          </li>
          {items.map((item, index) => (
            <li key={index} className="flex items-center">
              <i className="ri-arrow-right-s-line mx-1 text-foreground-300"></i>
              {item.path && index < items.length - 1 ? (
                <Link to={item.path} className="hover:text-primary-500 transition-colors whitespace-nowrap">
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground-700 whitespace-nowrap">{item.label}</span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}